import { useState } from "react";
import { api } from "../services/apiService";

export function InquiryForm({ source = "contact", submitLabel = "Send", successMessage = "Thanks! Our team will get back to you shortly.", messagePlaceholder = "How can we help? (optional)" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setStatus("submitting");
    setError("");
    try {
      await api.post("/leads", { ...form, source });
      setStatus("success");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      setStatus("error");
      setError(err.response?.data?.error?.message || err.message || "Unable to submit your request");
    }
  };

  if (status === "success") {
    return <p className="inquiry-success" style={{ fontSize: 14, marginTop: 20, maxWidth: 360 }}>{successMessage}</p>;
  }

  return (
    <form onSubmit={submit} style={{ display: "grid", gap: 12, marginTop: 20, maxWidth: 360 }}>
      <input required className="field-input" placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
      <input required type="email" className="field-input" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
      <input type="tel" className="field-input" placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
      <textarea className="field-input" placeholder={messagePlaceholder} rows={3} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
      {error && <p role="alert" style={{ color: "#ff6b6b", fontSize: 13, margin: 0 }}>{error}</p>}
      <button className="button button--lime" type="submit" disabled={status === "submitting"}>
        {status === "submitting" ? "Submitting…" : submitLabel}
      </button>
    </form>
  );
}
